// options = { leading: true, trailing: false }
// Unit tests: https://github.com/jashkenas/underscore/blob/master/test/functions.js#L197

export default function throttle (func, wait, options = {}) {
    if (!options.hasOwnProperty('leading')) {
        options.leading = true
    }
    let context
    let args
    let result
    let timeout = null
    let previous = 0
    const later = () => {
        previous = !options.leading ? 0 : Date.now()
        timeout = null
        result = func.apply(context, args)
        if (!timeout) {
            context = args = null
        }
    }
    return function () {
        const now = Date.now()
        if (!previous && !options.leading) {
            previous = now
        }
        const remaining = wait - (now - previous)
        context = this
        args = arguments
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout)
                timeout = null
            }
            previous = now
            result = func.apply(context, args)
            if (!timeout) {
                context = args = null
            }
        } else if (!timeout && options.trailing) {
            timeout = setTimeout(later, remaining)
        }
        return result
    }
}



// WEBPACK FOOTER //
// ./node_modules/nespresso-library/src/utils/throttle.js